import {
    Button,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
} from "@mui/material"
import { makeStyles } from "@mui/styles"
import { fCurrency } from "../../utils/formatNumbers"
import { useEffect, useState } from "react"
import api from "../../services/api"
import { invoicesStatusMap } from "../../utils/planRouteNames"

import { format } from "date-fns"

const useStyles = makeStyles((theme) => ({
    fullWidth: {
        width: "100%",
    },
    tableContainer: {
        width: "100%",
        overflowX: "scroll",
        ...theme.scrollbarStyles,
    },
}))

function PaymentList() {
    const classes = useStyles()
    const [records, setRecords] = useState([])

    async function getData() {
        try {
            const { data } = await api.get("/subscription/payments")
            setRecords(data.results)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getData()
    }, [])

    return (
        <Paper className={classes.tableContainer}>
            <Table
                className={classes.fullWidth}
                size="small"
                aria-label="a dense table"
            >
                <TableHead>
                    <TableRow>
                        <TableCell align="center" style={{ width: "1%" }}>
                            #
                        </TableCell>
                        <TableCell align="left">Nome</TableCell>
                        <TableCell align="left">Status</TableCell>
                        <TableCell align="left">Valor</TableCell>
                        <TableCell align="left">Data</TableCell>
                        <TableCell align="left">Vencimento</TableCell>
                        <TableCell align="left">Link</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {records.map((row, key) => (
                        <TableRow key={key}>
                            <TableCell align="left">{row._id}</TableCell>
                            <TableCell align="left">
                                {row.client.name}
                            </TableCell>
                            <TableCell align="left">
                                {invoicesStatusMap[row.status]}
                            </TableCell>
                            <TableCell align="left">
                                {fCurrency(row.totalValue / 100)}
                            </TableCell>
                            <TableCell>
                                {format(row.createdAt, "dd/MM/yyyy")}
                            </TableCell>
                            <TableCell>
                                {format(row.dueDate, "dd/MM/yyyy")}
                            </TableCell>
                            <TableCell>
                                <Button
                                    href={row.linkCheckout}
                                    target="_blank"
                                    disabled={row.status === "paid"}
                                >
                                    Pagar
                                </Button>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </Paper>
    )
}

export default PaymentList
